import type { FaireProductEntity } from "../../entity_types/product";

export const p_ftk98xvcju: FaireProductEntity = {
  token: "p_ftk98xvcju",
  type: "product",
  name: "Gold Classic Sunflower Charm",
  brandToken: "b_w6uc4cj54d",
  brandName: "The Charm Bar Company",
  imageUrl:
    "https://cdn.faire.com/fastly/7ed89e14d265c1dcee64e2fb6d67a1b567b4ac2a5f5237fb297640d6b67e7256.png",
  galleryImageUrls: [],
  priceDollars: 4.5,
  description:
    "\nOur Classic Sunflower Charm embodies the essence of summertime and nature's beauty. The intricate detail of the charm captures the warmth of sunshine and the delicate elegance of a blooming sunflower. With this charm, you can carry a piece of summer with you wherever you go.\n\n * 18K Gold Plated Brass\n\n * Yellow and brown sunflower charm \n * Size: About 21x18x2mm \nAll charms come with 18 gauge 24k gold plated stainless steel jump rings, pre-installed to each charm.\n\nOur jewelry is carefully curated to make you feel beautiful and confident. We take pride in utilizing premium components sourced from high-quality materials. \n\nFor instructions on install charms to necklace or carabiner, please see our video tutorial here.\n",
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:28.688Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
